import { useTranslation } from "react-i18next";
import slideImage from "@/assets/onboarding-slide-3-v2.webp";

export function OnboardingSlideTwo() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full px-6 pb-32 relative overflow-hidden">
      {/* Animated background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-32 -left-20 w-64 h-64 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--accent) / 0.12) 0%, transparent 70%)',
            filter: 'blur(45px)',
          }}
        />
        <div 
          className="absolute top-1/4 -right-16 w-52 h-52 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--primary) / 0.1) 0%, transparent 70%)',
            filter: 'blur(35px)',
            animationDelay: '1s',
          }}
        />
        <div 
          className="absolute bottom-1/3 left-1/3 w-48 h-48 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--primary) / 0.08) 0%, transparent 70%)',
            filter: 'blur(40px)',
            animationDelay: '2s',
          }}
        />
      </div>

      {/* Image - fixed dimensions to prevent CLS */}
      <img
        src={slideImage}
        alt="Detail level selection"
        width={344}
        height={459}
        className="w-[344px] h-auto max-w-full"
        loading="lazy"
      />

      {/* Text content with glass card */}
      <div 
        className="text-center w-full max-w-xs mt-4 relative z-10 px-6 py-5 rounded-2xl"
        style={{
          background: 'linear-gradient(135deg, hsl(var(--card) / 0.6), hsl(var(--card) / 0.3))',
          backdropFilter: 'blur(20px) saturate(180%)',
          border: '1px solid hsl(var(--border) / 0.3)',
        }}
      >
        <h1 className="text-2xl font-bold text-foreground mb-3 leading-snug">
          {t("onboarding.everythingMatches.title")}
        </h1>
        <p className="text-muted-foreground text-base leading-relaxed">
          {t("onboarding.everythingMatches.subtitle")}
        </p>
      </div>
    </div>
  );
}
